<template>
  <span>{{ formattedDate }}</span>
</template>
<script>
export default {
  data() {
    return {
      formattedDate: ''
    };
  },
  props: {
      'date':'',
      args: {type: String, default: 'yyyy-MM-dd HH:mm:ss'},
  },
  methods: {
    formatDate() {
      const dt = new Date(this.date);
      if(isNaN(dt)) return '';
      const year = dt.getFullYear();
      const month = (dt.getMonth() + 1).toString().padStart(2, '0');
      const date = dt.getDate().toString().padStart(2, '0');
      const hour = dt.getHours().toString().padStart(2, '0');
      const minute = dt.getMinutes().toString().padStart(2, '0');
      const second = dt.getSeconds().toString().padStart(2, '0');
      let thisargs=this.args;
      if (thisargs === 'yyyy-M-d') {
        this.formattedDate = `${year}-${month}-${date}`;
      } else if (thisargs === 'yyyy-M-d H:m:s') {
        this.formattedDate = `${year}-${month}-${date} ${hour}:${minute}:${second}`;
      } else if (thisargs === 'yyyy-MM-dd') {
        this.formattedDate = `${year}-${month}-${date}`;
      } else if (thisargs === 'HH:mm:ss') {
        this.formattedDate = `${hour}:${minute}:${second}`;
      } else {
        this.formattedDate = `${year}-${month}-${date} ${hour}:${minute}:${second}`;
      }
    }
  },
  watch: {
    date() {
      this.formatDate();
    },
    args() {
      this.formatDate();
    }
  },
  mounted() {
    this.formatDate();
  }
};
</script>